import React, {useEffect, useState } from "react";
import "../assets/css/header.css";
import brand_logo from "../assets/images/Aurm_Logo.svg";
import close_icon from "../assets/images/nav_menu_close_icon.svg";
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";
const react_app_main_site_url = process.env.REACT_APP_MAIN_SITE_URL;
const react_app_blog_url = process.env.REACT_APP_BLOGS_URL;

/**
  Shows the NavBar Header.
*/
function HeaderComponent() {
  
  const scrollToSection = (sectionName) => {
    const scroller_section_tag = document.getElementById(sectionName);
    if (scroller_section_tag) {
      scroller.scrollTo(sectionName, {
        duration: 50,
        smooth: true,
      });
    }
  };

  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsScrolled(scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section id="header_section">
      <header id="header_container" className={isScrolled ? "fixed" : ""}>
        <nav
          className={`container navbar navbar-expand-md nav_container_div ${
            isOpen ? "open" : ""
          }`}
          id="header_nav_container"
        >
          <a className="navbar_brand" href="/">
            <img className="aurm_logo" src={brand_logo} alt="aurm" />
          </a>
          <span className="d-flex">
          <div className="nav_action_buttons overflow-hidden d-none" id="nav_bar_static_btn_section">
            <div className="button_spacing header_book_a_demo_button_div">
              <a href="https://api.whatsapp.com/send/?phone=919740741016&text=I'm intrigued about Aurm. Tell me more! &type=phone_number&app_absent=0" target="_blank" rel="noreferrer">
                <button className="header_book_a_demo_button" id="static_demo_btn">Book a demo</button>
              </a>
            </div>
          </div>
          <button id="navbar_toggler_btn" type="button" onClick={toggleNavbar}>
            {isOpen ? (
              <div className="custom_toggler_close_icon">
                <img src={close_icon} alt="close-icon" />
              </div>
            ) : (
              <>
                <span className="custom_toggler_icon d-block"></span>
                <span className="custom_toggler_icon d-block"></span>
                <span className="custom_toggler_icon d-block"></span>
              </>
            )}
          </button>
          </span>
          <div
            className={`collapse navbar-collapse justify-content-end navigation-actions navbar_collapsed ${
              isOpen ? "show" : ""
            }`}
          >
            <ul className="navbar-nav navbar_list">
              <li className="nav-item" id="ourstory_nav_option">
                <a href={`${react_app_main_site_url}/our_story`} target="_blank" rel="noopener noreferrer">
                  <div className="nav_action_buttons overflow-hidden">
                    <div className="button_spacing">
                      <div className="nav_options">Our Story</div>
                    </div>
                  </div>
                </a>
              </li>
              <li className="nav-item" id="blogs_nav_option">
                <a href={`${react_app_blog_url}`} target="_blank" rel="noopener noreferrer">
                  <div className="nav_action_buttons overflow-hidden">
                    <div className="button_spacing">
                      <div className="nav_options">Blog</div>
                    </div>
                  </div>
                </a>
              </li>
              <li className="nav-item" id="contact_or_book_demo_nav_option">
                  <div className="nav_action_buttons overflow-hidden">
                    <div className="button_spacing header_book_a_demo_button_div">
                      <a href="https://api.whatsapp.com/send/?phone=919740741016&text=I'm intrigued about Aurm. Tell me more! &type=phone_number&app_absent=0" target="_blank" rel="noreferrer">
                        <button className="header_book_a_demo_button">Book a demo</button>
                      </a>
                    </div>
                  </div>
              </li>
              <li
                className="nav-item d-none ms-3 mobile_head_option"
                id="get_in_touch_mobile_btn"
                >
                <Link
                  to="/"
                  onClick={() => {
                    scrollToSection("contact_section");
                    localStorage.setItem("scrollToSection", "contact_section");
                  }}
                >
                  <div className="mobile_touch_btn_div overflow-hidden">
                    <div className="touch_button_spacing">
                      <div className="nav_options text-truncate">
                        Get in Touch
                      </div>
                    </div>
                  </div>
                </Link>
              </li>
              <div className="d-none mobile_head_option" id="heads_footer">
                <div className="head_footer_item">
                  <a className="text-decoration-none" href="/">
                    <div className="head_footer_link_text">Cookie Settings</div>
                  </a>
                </div>
                <div className="head_footer_item">
                  <a className="text-decoration-none" href="/">
                    <div className="head_footer_link_text">Careers</div>
                  </a>
                </div>
                <div className="head_footer_item pb-0">
                  <a className="text-decoration-none" href="/">
                    <div className="head_footer_link_text">Legal</div>
                  </a>
                </div>
              </div>
            </ul>
          </div>
        </nav>
      </header>
    </section>
  );
}
export default HeaderComponent;
